import { EntityId } from '@reduxjs/toolkit';
import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import { DEFAULT_PARTICIPANTS_PAGE_SIZE, PRONO_BASE_PATH } from '../constants';
import {
  ParticipantsPageDTO,
  ParticipantsQuery,
  ParticipationOverride,
  PronoDrawDTO,
  PronoDrawRequestDTO,
  PronoGameInDTO,
  PronoGameOutDTO,
  PronoGamesPageDTO,
  PronoStatsResponseDTO,
  PronoUpdateDTO,
} from '../types';

export const pronoApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 20000 });

const BASE_PATH = PRONO_BASE_PATH;

export const createPronoGameApi = async (request: PronoGameOutDTO) => {
  const response = await pronoApi.api.post<PronoGameInDTO>(`${BASE_PATH}/games`, request, {});
  return response.data;
};

export const fetchPronoGamesApi = async (skip?: number, limit?: number) => {
  const response = await pronoApi.api.get<PronoGamesPageDTO>(`${BASE_PATH}/games`, {
    params: { skip, limit },
  });
  return response.data;
};

export const fetchPronoGameApi = async (gameId: EntityId) => {
  const response = await pronoApi.api.get<PronoGameInDTO>(`${BASE_PATH}/games/${gameId}`);
  return response.data;
};

export const updatePronoGameApi = async (gameId: EntityId, payload: PronoUpdateDTO) => {
  const response = await pronoApi.api.patch<PronoGameInDTO>(`${BASE_PATH}/games/${gameId}`, payload, {});
  return response.data;
};

export const setPronoParticipationApi = async (gameId: EntityId, override: ParticipationOverride | null) => {
  const response = await pronoApi.api.patch<PronoGameInDTO>(
    `${BASE_PATH}/games/${gameId}/participation`,
    { override },
    {},
  );
  return response.data;
};

export const deletePronoGameApi = async (gameId: EntityId) => {
  await pronoApi.api.delete(`${BASE_PATH}/games/${gameId}`);
  return gameId;
};

export const fetchPronoParticipantsApi = async (gameId: EntityId, query: ParticipantsQuery) => {
  const response = await pronoApi.api.get<ParticipantsPageDTO>(`${BASE_PATH}/games/${gameId}/participants`, {
    params: {
      skip: query.skip ?? 0,
      limit: query.limit ?? DEFAULT_PARTICIPANTS_PAGE_SIZE,
      mode: query.mode && query.mode !== 'all' ? query.mode : undefined,
      search: query.search || undefined,
    },
  });
  return response.data;
};

export const fetchPronoStatsApi = async (gameId: EntityId) => {
  const response = await pronoApi.api.get<PronoStatsResponseDTO>(`${BASE_PATH}/games/${gameId}/stats`);
  return response.data;
};

export const runPronoDrawApi = async (gameId: EntityId, payload: PronoDrawRequestDTO) => {
  const response = await pronoApi.api.post<PronoDrawDTO>(`${BASE_PATH}/games/${gameId}/draw`, payload, {});
  return response.data;
};

export const fetchPronoDrawApi = async (gameId: EntityId) => {
  const response = await pronoApi.api.get<PronoDrawDTO>(`${BASE_PATH}/games/${gameId}/draw`);
  return response.data;
};
